import styled from "styled-components";
import theme from "~/styles/theme";

export const Shade = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${theme.modalGradient};
  z-index: ${(props) => (props.open ? 100 : -1)};
  opacity: ${(props) => (props.open ? 1 : 0)};
  transition: ${theme.transition};
  cursor: pointer;
`;

export const Exit = styled.div`
  position: absolute;
  top: 0px;
  right: 0;
  border-radius: 50%;
  background: var(--cores-0D5BA8, #0D5BA8);
  width: 48px;
  height: 48px;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(50%, -50%);
  padding: 2px 0 0 2px;
`;

export const ModalBox = styled.div`
  border-radius: 16px;
  position: absolute;
  z-index: ${(props) => (props.open ? 101 : -1)};
  background: #E9EBF3;

  bottom: 0;
  left: 0;
  width: 100%;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: calc(100vw - 32px);
    max-width: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const TitleHolder = styled.div`
  text-align: center;

  h6 {
    margin: 24px 0 18px;
    text-align: center;
    
    color: var(--cores-0D5BA8, #0D5BA8);
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%; /* 26.4px */
  }
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    max-width: 196px;
    margin-bottom: 14px;
  }
`;

export const ImgHolder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  span {
    color: #1b1b19;
    margin-bottom: 12px;
  }
`;

export const BottomModal = styled.div`
  padding: 13px 15px 15px 20px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 13px 25px 15px 45px;
  }

  button {
    width: 100%;
  }

  p {
    font-size: 14px;
    line-height: 140%;

    strong {
      font-size: 14px;
      line-height: 140%;

      &.list-strong {
        color: #1b1b19;
      }
    }
  }

  ul {
    list-style: disc;

    li {
      margin-bottom: 20px;
      font-size: 14px;
      color: #1b1b19;
    }
  }
`;

export const BgHolder = styled.div`
  background: #ffffff;
  padding: 20px 40px;
  border-radius: 0 0 16px 16px;
`;

export const ButtonHolder = styled.div`
  margin: 0 24px 24px 24px;

  button {
    width: 100%;
  }
`;

export const ParagraphHolder = styled.div`
  p {
    font-size: 14px;
    color: #1b1b19;
    margin-bottom: 18px;
    font-weight: 500;
    strong {
      color: #1b1b19;
    }
  }
`;
